import { Service, inject } from '@angular/core';
import { NgxHttpClient } from '@degreed/lxp/services';
import { Observable } from 'rxjs';

export interface LinkData {
  links: Link[];
  linkSectionTitle: string;
}

export interface Link {
  title: string;
  url: string;
}

@Service()
export class OrgLinksService {
  private http = inject(NgxHttpClient);

  public getOrganizationLinks(
    orgId: number,
    forceRefresh = false
  ): Observable<LinkData> {
    return this.http.get<LinkData>('/organizations/getorganizationlinks', {
      params: {
        organizationId: orgId,
        v: forceRefresh ? Date.now() : undefined,
      },
    });
  }

  public updateOrganizationLinks(
    orgId: number,
    organizationLinksConfig: LinkData
  ) {
    return this.http.post('/organizations/updateorganizationlinks', {
      orgId,
      organizationLinksConfig,
    });
  }
}
